<template lang="pug">
    v-dialog(
    v-model="popupDialog"
    transition="dialog-bottom-transition"
    width="35%"
    content-class="dialog"
    )
        v-card
            v-toolbar(dense flat color="accent white--text" height="50px")
                v-fade-transition(mode="out-in")
                    v-toolbar-title Delete Quick Link

                v-spacer
                v-btn(icon @click.native="popupDialog = false")
                    v-icon close
            v-container
               v-layout(row wrap delete-msg)
                    v-flex(xs12 sm6 md11 flex-1)
                        span Are you sure you want to Delete? Deleting this link is permanent.
               v-layout(row wrap)
                    v-flex(xs12 sm12 md11 flex-1)
                        v-btn(
                        flat
                        @click.native="deleteQuickLink"
                        id="deleteQuickLinkBtn"
                        ).button-delete-quick-link Delete
                        v-btn(flat
                        @click.native="popupDialog = false").button-delete-cancel Cancel
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Base from '@/components/views/Base';
import { quicklink } from '@/api';


export default {
    name: 'DeleteQuickLinkModuleDialog',
    extends: Base,

    props: {
        qlSet: { type: String, required: true },
        showDialog: { type: Boolean, default: false },
        list: { type: Array, default: () => { return []; } },
        index: { type: Number, required: true },
        organisation: { type: String, required: true },
    },

    data() {
        return {
            valid: false,
            popupDialog: false,
            title: '',
        };
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.popupDialog = true;
            }
        },

        popupDialog(value) {
            if (!value) {
                this.$emit('closed');
            }
        },

    },

    computed: {
        ...mapState({
            subdomain: state => state.session.subdomain
        }),
        ...mapGetters({
            getContextItem: 'clientContext/getContextItem',
        }),
    },

    methods: {
        async LoadEditLink(editLink) {
            this.editLink = editLink;
        },
        async deleteQuickLink() {
            try {
                this.editLink.hidden = true;
                this.editLink.version += 1;
                this.editLink.updated_at = new Date();
                this.editLink.deleted = true;
                const response = await quicklink.createVersion(this.editLink, this.subdomain);
                this.list.push(response.data);
                this.$emit('reloadQuickList', this.index, this.list);
                this.showSuccessAlert('Success.');
            } catch (err) {
                const errorMessage = JSON.parse(JSON.stringify(err));
                this.showErrorAlert(`Error: ${errorMessage.response.data.error}`);
            } finally {
                this.popupDialog = false;
            }
        },
    }
};
</script>

<style scoped>
    .button-delete-quick-link {
        font-weight:bold;
        background-color: var(--v-secondary-base);
        color: white !important;
    }
    .button-delete-cancel {
        color: var(--v-secondary-base) !important;
        border:1px solid var(--v-secondary-base);
    }
    .delete-msg{
        margin-bottom:20px;
        font-weight: bold;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/content/DeleteQuickLinkModuleDialog.vue